var _ellipse, _circle, _circle2, _path, _path2, _path3, _path4, _circle3, _path5, _circle4, _path6, _path7, _path8, _path9, _path10, _circle5, _path11, _path12, _path13, _path14, _rect, _circle6, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspectElement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 125,
    fill: "none",
    viewBox: "0 0 121 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.57,
    cy: 117.637,
    fill: "#C5C5C5",
    fillOpacity: 0.6,
    rx: 53.052,
    ry: 6.409
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.204,
    cy: 34.021,
    r: 3.204,
    stroke: "#C5C5C5",
    strokeWidth: 1.78
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.219,
    cy: 91.602,
    r: 2.027,
    stroke: "#939090",
    strokeWidth: 1.158
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#939090",
    strokeWidth: 1.709,
    d: "M79.8922 11.0464V18.8308"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#939090",
    strokeWidth: 1.709,
    d: "M76 14.9385H83.7844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#939090",
    strokeWidth: 2.136,
    d: "M8.66328 84.0464V93.7769"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#939090",
    strokeWidth: 2.136,
    d: "M3.79785 88.9118H13.5284"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.001,
    cy: 3.204,
    r: 3.204,
    fill: "#C5C5C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M35 34.0464C35 31.8372 36.7909 30.0464 39 30.0464H117C119.209 30.0464 121 31.8372 121 34.0464V55.0464C121 57.2555 119.209 59.0464 117 59.0464H39C36.7909 59.0464 35 57.2555 35 55.0464V34.0464Z",
    clipRule: "evenodd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 44.046,
    r: 9,
    fill: "#E8E8E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9A7A7",
    strokeWidth: 2.502,
    d: "M45.6006 43.6451L49.0763 47.0461L55.1865 40.2441"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M65 41.0464C65 39.9418 65.8954 39.0464 67 39.0464H92C93.1046 39.0464 94 39.9418 94 41.0464C94 42.151 93.1046 43.0464 92 43.0464H67C65.8954 43.0464 65 42.151 65 41.0464Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M95 41.0464C95 39.9418 95.8954 39.0464 97 39.0464H109C110.105 39.0464 111 39.9418 111 41.0464C111 42.151 110.105 43.0464 109 43.0464H97C95.8954 43.0464 95 42.151 95 41.0464Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M88 48.0464C88 46.9418 88.8954 46.0464 90 46.0464H99C100.105 46.0464 101 46.9418 101 48.0464C101 49.151 100.105 50.0464 99 50.0464H90C88.8954 50.0464 88 49.151 88 48.0464Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M19 73.0464C19 70.8372 20.7909 69.0464 23 69.0464H92C94.2091 69.0464 96 70.8372 96 73.0464V94.0464C96 96.2555 94.2091 98.0464 92 98.0464H23C20.7909 98.0464 19 96.2555 19 94.0464V73.0464Z",
    clipRule: "evenodd"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 85.046,
    r: 9,
    fill: "#E8E8E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9A7A7",
    strokeWidth: 2.502,
    d: "M29.6006 84.6451L33.0763 88.0461L39.1865 81.2441"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M49 82.0464C49 80.9418 49.8954 80.0464 51 80.0464H60C61.1046 80.0464 62 80.9418 62 82.0464C62 83.151 61.1046 84.0464 60 84.0464H51C49.8954 84.0464 49 83.151 49 82.0464Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M63 82.0464C63 80.9418 63.8954 80.0464 65 80.0464H81C82.1046 80.0464 83 80.9418 83 82.0464C83 83.151 82.1046 84.0464 81 84.0464H65C63.8954 84.0464 63 83.151 63 82.0464Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#A9A7A7",
    fillRule: "evenodd",
    d: "M68 89.0464C68 87.9418 67.1046 87.0464 66 87.0464H51C49.8954 87.0464 49 87.9418 49 89.0464C49 90.151 49.8954 91.0464 51 91.0464H66C67.1046 91.0464 68 90.151 68 89.0464Z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 30,
    y: 47.046,
    fill: "#F1F0EE",
    rx: 4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 62.046,
    r: 9,
    fill: "#C5C5C5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeWidth: 3,
    d: "M10.1123 60.0712L14.9998 64.5083L24.4993 53.9629"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#918E8E",
    fillRule: "evenodd",
    d: "M30 59.0464C30 57.9418 30.8954 57.0464 32 57.0464H43C44.1046 57.0464 45 57.9418 45 59.0464C45 60.151 44.1046 61.0464 43 61.0464H32C30.8954 61.0464 30 60.151 30 59.0464Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#918E8E",
    fillRule: "evenodd",
    d: "M46 59.0464C46 57.9418 46.8954 57.0464 48 57.0464H74C75.1046 57.0464 76 57.9418 76 59.0464C76 60.151 75.1046 61.0464 74 61.0464H48C46.8954 61.0464 46 60.151 46 59.0464Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M30 66.0464C30 64.9418 30.8954 64.0464 32 64.0464H50C51.1046 64.0464 52 64.9418 52 66.0464C52 67.151 51.1046 68.0464 50 68.0464H32C30.8954 68.0464 30 67.151 30 66.0464Z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M53 66.0464C53 64.9418 53.8954 64.0464 55 64.0464H64C65.1046 64.0464 66 64.9418 66 66.0464C66 67.151 65.1046 68.0464 64 68.0464H55C53.8954 68.0464 53 67.151 53 66.0464Z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    fillRule: "evenodd",
    d: "M105.707 79.8053L89.4521 110.376L79.7396 105.211L95.9941 74.6411L105.707 79.8053Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M86.3197 116.267L89.0288 111.172L79.3164 106.007L76.6073 111.102C74.9988 114.128 84.7112 119.292 86.3197 116.267Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    fillRule: "evenodd",
    d: "M96.6612 73.7703L107.195 65.4831L106.214 78.8499L96.6612 73.7703Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectElement);
export default __webpack_public_path__ + "static/media/InspectElement.a9a3af712dd70cdd8f0da8148ea1f3c0.svg";
export { ForwardRef as ReactComponent };